var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_97_5708)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_97_5708",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_97_5708)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.47863 15L2.4364 17.0423C1.83683 17.6418 1.5 18.455 1.5 19.3029C1.5 21.0686 2.93137 22.5 4.69706 22.5C5.54497 22.5 6.35815 22.1632 6.95772 21.5636L8.99995 19.5214C8.98844 21.9968 6.97815 24 4.5 24C2.01472 24 0 21.9853 0 19.5C0 17.0218 2.00318 15.0116 4.47863 15Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 24C21.9853 24 24 21.9853 24 19.5C24 17.0218 21.9968 15.0116 19.5214 15L21.5636 17.0423C22.1632 17.6418 22.5 18.455 22.5 19.3029C22.5 21.0686 21.0686 22.5 19.3029 22.5C18.455 22.5 17.6418 22.1632 17.0423 21.5636L15 19.5214C15.0116 21.9968 17.0218 24 19.5 24Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 9C21.9853 9 24 6.98528 24 4.5C24 2.01472 21.9853 0 19.5 0C17.0218 0 15.0116 2.00318 15 4.47863L17.0423 2.4364C17.6418 1.83683 18.455 1.5 19.3029 1.5H19.3629C21.0955 1.5 22.5 2.90454 22.5 4.63712C22.5 5.56386 22.0903 6.44317 21.3806 7.03923L19.0705 8.97977C19.2119 8.99315 19.3551 9 19.5 9Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 4.5C0 6.97815 2.00318 8.98844 4.47863 8.99995L2.4364 6.95772C1.83683 6.35815 1.5 5.54497 1.5 4.69706C1.5 2.93137 2.93137 1.5 4.69706 1.5C5.54497 1.5 6.35815 1.83683 6.95772 2.4364L8.99995 4.47863C8.98844 2.00318 6.97815 0 4.5 0C2.01472 0 0 2.01472 0 4.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.69706 3C3.7598 3 3 3.7598 3 4.69706C3 5.14714 3.1788 5.5788 3.49706 5.89706L7.41421 9.81421C7.78929 10.1893 8 10.698 8 11.2284V12.7716C8 13.302 7.78929 13.8107 7.41421 14.1858L3.49706 18.1029C3.1788 18.4212 3 18.8529 3 19.3029C3 20.2402 3.7598 21 4.69706 21C5.14714 21 5.5788 20.8212 5.89706 20.5029L9.81421 16.5858C10.1893 16.2107 10.698 16 11.2284 16H12.7716C13.302 16 13.8107 16.2107 14.1858 16.5858L18.1029 20.5029C18.4212 20.8212 18.8529 21 19.3029 21C20.2402 21 21 20.2402 21 19.3029C21 18.8529 20.8212 18.4212 20.5029 18.1029L16.5858 14.1858C16.2107 13.8107 16 13.302 16 12.7716V10.532C16 9.94116 16.2612 9.38057 16.7136 9.00056L20.4159 5.89068C20.7862 5.57962 21 5.12074 21 4.63712C21 3.73296 20.267 3 19.3629 3H19.3029C18.8529 3 18.4212 3.1788 18.1029 3.49706L14.1858 7.41421C13.8107 7.78929 13.302 8 12.7716 8H11.2284C10.698 8 10.1893 7.78929 9.81421 7.41421L5.89706 3.49706C5.5788 3.1788 5.14714 3 4.69706 3ZM12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14Z",
    fill: "currentColor"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_97_5708"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrone);
export default __webpack_public_path__ + "static/media/drone.b66323c4b6de45f3df3205539323abbc.svg";
export { ForwardRef as ReactComponent };